import React from "react";

export default function PublishAction(props) {
    return (
        <div className="text-sm text-gray-800">
            Items will be automatically published.
        </div>
    );
}
